import AllocationList from "./AllocationList";

export default AllocationList;